import React, { useState } from "react";
import Button from "../../components/buttons/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAward } from "@fortawesome/free-solid-svg-icons";
import { PartnerStatus, updateStatus } from "../../services/partner.service";
import showToast from "../../utils/show.toast";
import { useNavigate } from "react-router-dom";
import "./StatusUpdateButton.scss";

interface IPartnerStatus {
  requestId: string;
  status: PartnerStatus;
  listStatus: string;
}

const StatusUpdateButton = ({
  listStatus,
  requestId,
  status,
}: IPartnerStatus) => {
  const [action, setAction] = useState<string | null>(null);
  const navigate = useNavigate();

  const update = async (givenstatus: PartnerStatus, actionName: string) => {
    setAction(actionName);

    try {
      const response = await updateStatus(
        `merchants/partners/update-status/${requestId}`,
        { status: givenstatus }
      );

      if (response.statusCode === 404 || response.status !== "success") {
        showToast(`Merchant was not ${givenstatus.toLocaleLowerCase()}`, false);
        setAction(null);
      } else {
        showToast(
          `Merchant ${givenstatus.toLocaleLowerCase()} successfully!`,
          true
        );
        setAction(null);
        return navigate(`/partners/list?status=${listStatus}`);
      }
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : "Apologies, an unexpected error occured!";
      showToast(message, false);
    }
  };

  return (
    <div className={`partner-status ${status.toLowerCase()}`}>
      <div className="partner-status-badge">
        <FontAwesomeIcon icon={faAward} className="partner-icon" />
        <h5>
          {status === PartnerStatus.REGISTERED && "Unreviewed Partner"}
          {status === PartnerStatus.ACCEPTED && "Reviewed Partner"}
          {status === PartnerStatus.VERIFIED && "Verified Partner"}
          {status === PartnerStatus.SUSPENDED && "Suspended Partner"}
        </h5>
      </div>

      <div className="partner-status-actions">
        {status === PartnerStatus.REGISTERED && (
          <>
            <Button
              name="Approve"
              type="activate-button"
              isLoading={action === "approve"}
              loadingText="Approving..."
              onClick={() => update(PartnerStatus.ACCEPTED, "approve")}
            />
            <Button
              name="Reject"
              type="delete-button"
              isLoading={action === "reject"}
              loadingText="Rejecting..."
              onClick={() => update(PartnerStatus.REJECTED, "reject")}
            />
          </>
        )}

        {status === PartnerStatus.ACCEPTED && (
          <>
            <Button
              name="Verify"
              type="activate-button"
              isLoading={action === "verify"}
              loadingText="Verifying..."
              onClick={() => update(PartnerStatus.VERIFIED, "verify")}
            />
            <Button
              name="Reject"
              type="delete-button"
              isLoading={action === "reject"}
              loadingText="Rejecting..."
              onClick={() => update(PartnerStatus.REJECTED, "reject")}
            />
          </>
        )}

        {status === PartnerStatus.VERIFIED && (
          <Button
            name="Suspend"
            type="activate-button"
            isLoading={action === "suspend"}
            loadingText="Suspending..."
            onClick={() => update(PartnerStatus.SUSPENDED, "suspend")}
          />
        )}

        {status === PartnerStatus.SUSPENDED && (
          <>
            <Button
              name="Approve"
              type="activate-button"
              isLoading={action === "approve"}
              loadingText="Approving..."
              onClick={() => update(PartnerStatus.ACCEPTED, "approve")}
            />
            <Button
              name="Deactivate"
              type="delete-button"
              isLoading={action === "deactivate"}
              loadingText="Deactivating..."
              onClick={() => update(PartnerStatus.DEACTIVATED, "deactivate")}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default StatusUpdateButton;
